const surchargeBrackets = {
  new: [
    { threshold: 20000000, rate: 0.25 },
    { threshold: 10000000, rate: 0.15 },
    { threshold: 5000000, rate: 0.1 },
  ],
  old: [
    { threshold: 50000000, rate: 0.37 },
    { threshold: 20000000, rate: 0.25 },
    { threshold: 10000000, rate: 0.15 },
    { threshold: 5000000, rate: 0.1 },
  ],
};

export const calculateSurcharge = ({
  taxableIncome,
  baseTax,
  calculateBaseTax,
  regime,
}) => {
  const bracket = surchargeBrackets[regime].find(
    ({ threshold }) => taxableIncome > threshold
  );

  if (!bracket || baseTax <= 0) {
    return {
      surcharge: 0,
      surchargeRate: 0,
      surchargeApplies: false,
      surchargeMarginalRelief: 0,
    };
  }

  const taxWithUnadjustedSurcharge = baseTax * (1 + bracket.rate);
  const taxAtThreshold = calculateBaseTax(bracket.threshold);
  const maximumTaxAfterRelief =
    taxAtThreshold + (taxableIncome - bracket.threshold);
  const taxWithSurcharge = Math.min(
    taxWithUnadjustedSurcharge,
    maximumTaxAfterRelief
  );
  const surcharge = taxWithSurcharge - baseTax;

  return {
    surcharge,
    surchargeRate: bracket.rate * 100,
    surchargeApplies: true,
    surchargeMarginalRelief:
      taxWithUnadjustedSurcharge - taxWithSurcharge,
  };
};

export const calculateFinalTax = ({
  baseTax,
  surcharge,
  professionalTax = 200,
}) => {
  const cess = (baseTax + surcharge) * 0.04;

  return {
    cess,
    professionalTax,
    finalTax: baseTax + surcharge + cess + professionalTax,
  };
};
